import { BaseListResponse, ListItemLoader, RequestFactory, RequestSender } from '../core'

export { BaseListResponse, ListItemLoader, RequestSender }

export const GerberaRequestFactory = new RequestFactory({
  baseUrl: process.env.GERBERA_BASE_URL,
  timeout: 10000,
  contentType: 'application/json',
  withCredentials: true
})

export type PublishStatus = 'published' | 'reserved' | 'pending'

export function isPublishStatus(value: string): value is PublishStatus {
  return value === 'published' || value === 'reserved' || value === 'pending'
}

export interface BaseApiRequest {
  page?: number
  perPage?: number
  categoryId?: number | null
  status?: PublishStatus,
  title?: string
  orderBy?: (ContentOrderBy | CategoryOrderBy)[]
}

export type ContentSortKey = 'createdDate' | 'modifiedDate' | 'publishedDate' | 'fileSize'

export function isContentSortKey(value: string): value is ContentSortKey {
  return value === 'createdDate' || value === 'modifiedDate' || value === 'publishedDate' || value === 'fileSize'
}

export interface ContentOrderBy {
  key: ContentSortKey
  isDescending?: boolean
}

export type CategorySortKey = 'createdDate' | 'modifiedDate' | 'categoryName' | 'contentCount' | 'menuOrder'

export interface CategoryOrderBy {
  key: CategorySortKey
  isDescending?: boolean
}

/** 画像データ */
export interface ImageContent {
  fileName: string
  dataUrl: string
}

export interface BaseApiRequestParams {
  page?: number | ''
  perPage?: number | ''
  categoryId?: string
  uncategorized?: boolean
  status?: PublishStatus | ''
  title?: string
  _orderBy?: string
}

export function mapToRequestParams<T extends BaseApiRequest>(request: T): BaseApiRequestParams {
  const param: BaseApiRequestParams = {}
  if (request.categoryId === null) {
    // カテゴリ「未分類」
    param.uncategorized = true
  } else if (request.categoryId) {
    param.categoryId = request.categoryId.toString()
  }
  if (request.orderBy) {
    param._orderBy = request.orderBy
      .map(order => order.isDescending ? '-' + order.key : order.key)
      .join(',')
  }
  if (request.page) {
    param.page = request.page
  }
  if (request.perPage) {
    param.perPage = request.perPage
  }
  if (request.status) {
    param.status = request.status
  }
  if (request.title) {
    param.title = request.title
  }
  return param
}
